import { render } from "./OurTestimonials.vue?vue&type=template&id=384782c4"
import script from "./OurTestimonials.vue?vue&type=script&lang=js"
export * from "./OurTestimonials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__